import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=12a8f006&scoped=true&isFirst&isPage"
import script from "./index.mpx?vue&type=script&lang=js&isFirst&isPage"
export * from "./index.mpx?vue&type=script&lang=js&isFirst&isPage"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a8f006",
  null
  
)

export default component.exports